<template>
  <div class="modal" v-bind:class="{ 'is-active': is_shown }">
    <div class="modal-background" @click="close_modal"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t("permissions") }}</p>
        <button class="delete" aria-label="close" @click="close_modal"></button>
      </header>
      <section class="modal-card-body">
        <table class="table is-fullwidth">
          <thead>
            <tr>
              <th v-for="(role, ridx) in meta.roles" :key="ridx">
                {{ role.name }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td v-for="(role, rlidx) in meta.roles" :key="rlidx">
                <input
                  class="is-checkradio"
                  type="checkbox"
                  :id="'chk_report_permission' + rlidx"
                  :data-roid="role.role_id"
                  :checked="
                    meta.resources.find((p) => {
                      // console.log(p);
                      return Number(p.role_id) == Number(role.role_id);
                    })
                      ? true
                      : false
                  "
                  @click="toggle_permission(role.role_id, $event)"
                />
                <label :for="'chk_report_permission' + rlidx"></label>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="notification is-danger mt-5" v-if="error">
          <p v-html="error"></p>
        </div>
        <!-- <pre>{{ meta }}</pre> -->
      </section>
      <footer class="modal-card-foot">
        <p class="buttons">
          <button class="button is-rounded is-danger" @click="close_modal">
            <span class="icon"><i class="fa fa-close"></i></span>
            <span>{{ $t("close") }}</span>
          </button>
        </p>
      </footer>
    </div>
  </div>
</template>
<script>
import { get, post, generate_error_message_text } from "@/utils";

export default {
  name: "ReportPermissionsModal",
  // components: { Permissions },
  data() {
    return {
      is_shown: false,
      meta: {},
      report: "",
      error: "",
    };
  },
  computed: {
    is_form_valid() {
      return true;
      // let v = this;
      // return !v.meta.name;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.is_shown = false;
      v.set_initial_state();
    },
    show_modal(report) {
      // console.log("showing permissions modal", report.report_id);
      let v = this;
      v.is_shown = true;
      v.report = report;
      v.set_initial_state();
      v.init();
    },
    init() {
      let v = this;
      // Get the module and its permissions
      get("/report/permissions", { uuid: v.report.uuid })
        .then((response) => {
          v.meta = response;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      this.meta = {};
      this.uuid = "";
      this.error = "";
    },
    toggle_permission(role_id, event) {
      let v = this;
      let value = window.jQuery(event.srcElement).is(":checked");

      post("/report/permission", {
        role_id,
        report_id: v.report.report_id,
        event,
        value,
      })
        .then(() => {
          // v.init();
          // console.log("permissions updated");
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
  },
  mounted() {},
};
</script>
<style></style>
